module.exports = __webpack_public_path__ + "img/moon-cloud.7688268.svg";